// Complete File updated by Imran Khan - Warranty List redesigned to match AMC List UI on 29 April 2026
import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Table,
  Form,
  Modal,
  FormGroup,
  FormLabel,
} from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";

import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { ROUTES } from "../../constants/webRouting";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/DateRangePicker/styles/index.css";
import ".././../assets/css/ListComponentsTable.css";
import {
  formatDate,
  formatDateForView,
  getUserDetails,
} from "../../utils/helper";
import * as Constant from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import UserMultiSelect from "../common/UserMultiSelect";
import moment from "moment";
import PubSub from "pubsub-js";

/* ─── Inline Responsive Styles ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Space+Grotesk:wght@400;500;600;700&display=swap');

  * { box-sizing: border-box; }

  .wrn-root {
    background: #f0f4f9;
    min-height: 100vh;
    padding: 20px 16px;
    font-family: 'DM Sans', sans-serif;
  }

  /* ── Page Header ── */
  .wrn-page-title { font-size: 20px; font-weight: 600; color: #1a1d23; margin-bottom: 2px; font-family: 'Space Grotesk', sans-serif; }
  .wrn-breadcrumb { font-size: 12px; color: #9098a9; margin-bottom: 3px; }
  .wrn-breadcrumb a { color: #378ADD; text-decoration: none; }
  .wrn-page-desc { font-size: 12px; color: #b0b8c8; margin-bottom: 20px; }

  /* ── Stat Cards Grid ── */
  .wrn-stat-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
    margin-bottom: 20px;
  }
  @media (max-width: 1400px) { .wrn-stat-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (max-width: 768px)  { .wrn-stat-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; } }
  @media (max-width: 480px)  { .wrn-stat-grid { grid-template-columns: 1fr 1fr; gap: 8px; } }

  /* ── Stat Card ── */
  .wrn-stat-card {
    background: #fff;
    border: 1px solid #e8edf5;
    border-radius: 14px;
    padding: 14px 14px 10px;
    cursor: pointer;
    transition: box-shadow .18s, transform .18s, border-color .18s;
    position: relative;
    overflow: hidden;
  }
  .wrn-stat-card:hover {
    box-shadow: 0 6px 24px rgba(55,138,221,.13);
    transform: translateY(-2px);
    border-color: #c8d8ee;
  }
  .wrn-stat-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 3px;
    border-radius: 14px 14px 0 0;
    background: var(--accent-color, #378ADD);
    opacity: 0;
    transition: opacity .2s;
  }
  .wrn-stat-card:hover::before { opacity: 1; }
  .wrn-stat-icon {
    width: 34px; height: 34px; border-radius: 9px;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 10px;
  }
  .wrn-stat-label { font-size: 10px; font-weight: 600; color: #9098a9; text-transform: uppercase; letter-spacing: .05em; margin-bottom: 4px; }
  .wrn-stat-num { font-size: 22px; font-weight: 700; line-height: 1; margin-bottom: 3px; font-family: 'Space Grotesk', sans-serif; }
  .wrn-stat-sub { font-size: 10px; color: #b0b8c8; }
  .wrn-sparkline { margin-top: 8px; width: 100%; height: 26px; }

  /* ── Insights Section ── */
  .wrn-insights-title {
    font-size: 13px; font-weight: 600; color: #1a1d23;
    margin-bottom: 12px; display: flex; align-items: center; gap: 7px;
    font-family: 'Space Grotesk', sans-serif;
  }

  /* ── Insights Grid ── */
  .wrn-insights-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 20px;
  }
  @media (max-width: 1200px) { .wrn-insights-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 640px)  { .wrn-insights-grid { grid-template-columns: 1fr; } }

  /* ── Insight Card ── */
  .wrn-insight-card {
    background: #fff;
    border: 1px solid #e8edf5;
    border-radius: 14px;
    overflow: hidden;
  }
  .wrn-insight-card-head {
    padding: 11px 15px;
    font-size: 10px; font-weight: 700;
    color: #9098a9; text-transform: uppercase;
    letter-spacing: .07em;
    border-bottom: 1px solid #f0f4f9;
    background: #fafbfd;
  }
  .wrn-insight-card-body { padding: 14px 15px; }

  /* ── Filter Card ── */
  .wrn-filter-card {
    background: #fff;
    border: 1px solid #e8edf5;
    border-radius: 14px;
    padding: 16px 18px;
    margin-bottom: 12px;
  }
  .wrn-filter-label {
    font-size: 10px; font-weight: 700; color: #9098a9;
    text-transform: uppercase; letter-spacing: .05em;
    margin-bottom: 5px; display: block;
  }
  .wrn-filter-select {
    border: 1px solid #dde3ef;
    border-radius: 8px; padding: 7px 10px;
    font-size: 12px; color: #333; background: #fff;
    width: 100%; outline: none;
    transition: border-color .15s;
    font-family: 'DM Sans', sans-serif;
  }
  .wrn-filter-select:focus { border-color: #378ADD; }
  .wrn-advanced-toggle {
    font-size: 12px; color: #378ADD; cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    margin-top: 10px; user-select: none; padding: 0;
    background: none; border: none; font-family: 'DM Sans', sans-serif;
    transition: opacity .15s;
  }
  .wrn-advanced-toggle:hover { opacity: .75; }

  /* ── Buttons ── */
  .wrn-btn-primary {
    background: #378ADD; border: none; border-radius: 8px;
    padding: 7px 14px; font-size: 12px; color: #fff;
    cursor: pointer; font-weight: 600; display: inline-flex;
    align-items: center; gap: 5px; white-space: nowrap;
    transition: background .15s, transform .12s;
    font-family: 'DM Sans', sans-serif;
  }
  .wrn-btn-primary:hover { background: #2a6eb8; transform: translateY(-1px); }
  .wrn-btn-secondary {
    background: #f0f4f9; border: 1px solid #dde3ef; border-radius: 8px;
    padding: 7px 12px; font-size: 12px; color: #555; cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px; white-space: nowrap;
    transition: background .15s; font-family: 'DM Sans', sans-serif;
  }
  .wrn-btn-secondary:hover { background: #e0e8f4; }

  /* ── Table Card ── */
  .wrn-table-card {
    background: #fff; border: 1px solid #e8edf5;
    border-radius: 14px; overflow: hidden; margin-bottom: 12px;
  }
  .wrn-table-head {
    display: flex; align-items: center; justify-content: space-between;
    padding: 13px 18px; border-bottom: 1px solid #f0f4f9;
    flex-wrap: wrap; gap: 8px;
  }
  .wrn-table-title { font-size: 14px; font-weight: 600; color: #1a1d23; font-family: 'Space Grotesk', sans-serif; }
  .wrn-table-count { font-size: 12px; color: #9098a9; font-weight: 400; margin-left: 4px; }
  .wrn-table-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
  .wrn-table-foot {
    padding: 10px 18px;
    border-top: 1px solid #f0f4f9;
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 8px;
  }
  .wrn-table-foot-text { font-size: 12px; color: #9098a9; }

  /* ── Progress Bar ── */
  .wrn-progress-track { height: 5px; background: #f0f4f9; border-radius: 3px; }
  .wrn-progress-fill { height: 5px; border-radius: 3px; transition: width .4s ease; }

  /* ── Donut ── */
  .wrn-donut-wrap { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }

  /* ── Retention row ── */
  .wrn-retention-row {
    display: flex; align-items: center; gap: 10px;
    padding: 8px 0; border-bottom: 1px solid #f0f4f9;
    cursor: pointer; transition: background .12s;
    border-radius: 6px; padding-left: 4px;
  }
  .wrn-retention-row:hover { background: #f7fafd; }
  .wrn-retention-row:last-child { border-bottom: none; }

  /* ── Legend pill ── */
  .wrn-legend-pill {
    font-size: 10px; font-weight: 600; padding: 2px 7px;
    border-radius: 999px; white-space: nowrap;
  }

  /* ── Filter Row responsive ── */
  .wrn-filter-row { display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-end; }
  .wrn-filter-col { min-width: 120px; flex: 1 1 120px; }
  .wrn-filter-col-lg { min-width: 180px; flex: 2 1 180px; }
  .wrn-filter-col-sm { min-width: 90px; flex: 1 1 90px; }
  .wrn-filter-actions { display: flex; gap: 6px; flex-wrap: wrap; align-items: flex-end; flex: 0 0 auto; }

  @media (max-width: 576px) {
    .wrn-filter-col, .wrn-filter-col-lg, .wrn-filter-col-sm { flex: 1 1 100%; }
    .wrn-filter-actions { width: 100%; }
    .wrn-table-head { padding: 10px 12px; }
    .wrn-filter-card { padding: 12px; }
    .wrn-insight-card-body { padding: 10px 12px; }
    .wrn-stat-num { font-size: 18px; }
    .wrn-stat-card { padding: 12px 10px 8px; }
  }
`;

// 8 important statuses from WARRANTY_STATUS_VALUES constant
const WARRANTY_STATUS_CONFIG = [
  {
    label: "Order Work in Progress",
    color: "#1E90FF",
    iconBg: "#E3F0FF",
    iconColor: "#0A5DB5",
    fa: "fa-solid fa-gear",
  },
  {
    label: "Order Work Complete",
    color: "#eb0c61",
    iconBg: "#FCE3EE",
    iconColor: "#9B0040",
    fa: "fa-solid fa-circle-check",
  },
  {
    label: "Warranty Running",
    color: "#7851A9",
    iconBg: "#EDE7F6",
    iconColor: "#4A2D7A",
    fa: "fa-solid fa-shield-halved",
  },
  {
    label: "Warranty Lost",
    color: "#476038",
    iconBg: "#E8EDE5",
    iconColor: "#2C3D22",
    fa: "fa-solid fa-shield-xmark",
  },
  {
    label: "AMC Running",
    color: "#008080",
    iconBg: "#E0F2F2",
    iconColor: "#004D4D",
    fa: "fa-solid fa-rotate",
  },
  {
    label: "AMC Lost",
    color: "#E24B4A",
    iconBg: "#FCEBEB",
    iconColor: "#A32D2D",
    fa: "fa-solid fa-ban",
  },
  {
    label: "AMC Direct Order",
    color: "#2aada7",
    iconBg: "#E0F5F5",
    iconColor: "#1A7570",
    fa: "fa-solid fa-rocket",
  },
  {
    label: "One Time",
    color: "#9b3131",
    iconBg: "#F5E5E5",
    iconColor: "#6B1E1E",
    fa: "fa-solid fa-calendar-day",
  },
];

const MONTHS = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

/* ── Sparkline ── */
const Sparkline = ({ color, points }) => (
  <svg className="wrn-sparkline" viewBox="0 0 120 26" preserveAspectRatio="none">
    <polyline
      points={points}
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ── Stat Card ── */
const StatCard = ({ icon, iconBg, iconColor, label, num, numColor, sub, sparkColor, sparkPoints, onClick, accentColor }) => (
  <div
    className="wrn-stat-card"
    style={{ "--accent-color": accentColor || numColor || "#378ADD" }}
    onClick={onClick}
  >
    <div className="wrn-stat-icon" style={{ background: iconBg }}>
      <i className={icon} style={{ fontSize: 14, color: iconColor }}></i>
    </div>
    <div className="wrn-stat-label">{label}</div>
    <div className="wrn-stat-num" style={{ color: numColor || "#1a1d23" }}>{num}</div>
    <div className="wrn-stat-sub">{sub}</div>
    {sparkPoints && <Sparkline color={sparkColor} points={sparkPoints} />}
  </div>
);

/* ── Donut Chart ── */
const DonutChart = ({ data, total }) => {
  const r = 48, cx = 56, cy = 56, circ = 2 * Math.PI * r;
  let offset = 0;
  const slices = data.map((d) => {
    const pct = total > 0 ? d.count / total : 0;
    const dash = pct * circ;
    const slice = { ...d, dash, offset, pct };
    offset += dash;
    return slice;
  });
  return (
    <svg width="112" height="112" viewBox="0 0 112 112" style={{ flexShrink: 0 }}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="#f0f4f9" strokeWidth="14" />
      {slices.map((s, i) => (
        <circle
          key={i} cx={cx} cy={cy} r={r} fill="none"
          stroke={s.color} strokeWidth="14"
          strokeDasharray={`${s.dash} ${circ - s.dash}`}
          strokeDashoffset={circ / 4 - s.offset}
        />
      ))}
      <text x={cx} y={cy - 5} textAnchor="middle" fontSize="15" fontWeight="700" fill="#1a1d23" fontFamily="'Space Grotesk', sans-serif">
        {total.toLocaleString("en-IN")}
      </text>
      <text x={cx} y={cy + 10} textAnchor="middle" fontSize="8" fill="#9098a9">TOTAL</text>
    </svg>
  );
};

const WarrantyList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();

  const [body, setBody] = useState();
  const [dateRange, setDateRange] = useState([]);
  const [warrantyEndDateRange, setWarrantyEndDateRange] = useState([]);
  const [filterData, setFilterData] = useState({ warranty_status: "Warranty Running" });
  const [orders, setOrders] = useState([]);
  const [assignUsers, setAssignUsers] = useState([]);
  const [endDateYear, setEndDateYear] = useState("");
  const [endDateMonth, setEndDateMonth] = useState("");
  const [showAdvanced, setShowAdvanced] = useState(false);

  // Transfer Owner states
  const [changeOwnerModal, setChangeOwnerModal] = useState(false);
  const [refreshRecords, setRefreshRecords] = useState(false);
  const [ownerLeads, setOwnerLeads] = useState([]);
  const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
  const [fromUser, setFromUser] = useState({});
  const [toUser, setToUser] = useState({});
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
  const [selectedToUsers, setSelectedToUsers] = useState([]);

  // ── Filtered body by year/month on warranty_end_date ──
  const filteredBody = useMemo(() => {
    if (!body || !Array.isArray(body)) return body;
    return body.filter((row) => {
      if (!row.warranty_end_date) return true;
      const d = new Date(row.warranty_end_date);
      if (isNaN(d)) return true;
      if (endDateYear && d.getFullYear().toString() !== endDateYear) return false;
      if (endDateMonth && (d.getMonth() + 1).toString() !== endDateMonth) return false;
      return true;
    });
  }, [body, endDateYear, endDateMonth]);

  const total = filteredBody?.length || 0;

  const statusCounts = useMemo(() => {
    if (!filteredBody || !Array.isArray(filteredBody)) return {};
    return filteredBody.reduce((acc, r) => {
      acc[r.warranty_status] = (acc[r.warranty_status] || 0) + 1;
      return acc;
    }, {});
  }, [filteredBody]);

  const statusCards = useMemo(
    () =>
      WARRANTY_STATUS_CONFIG.filter((c) => statusCounts[c.label])
        .map((c) => ({ ...c, count: statusCounts[c.label] }))
        .sort((a, b) => b.count - a.count),
    [statusCounts],
  );

  const workInProgressCount  = statusCounts["Order Work in Progress"] || 0;
  const workCompleteCount    = statusCounts["Order Work Complete"] || 0;
  const warrantyRunningCount = statusCounts["Warranty Running"] || 0;
  const warrantyLostCount    = statusCounts["Warranty Lost"] || 0;
  const amcRunningCount      = statusCounts["AMC Running"] || 0;
  const amcLostCount         = statusCounts["AMC Lost"] || 0;
  const amcDirectOrderCount  = statusCounts["AMC Direct Order"] || 0;
  const oneTimeCount         = statusCounts["One Time"] || 0;

  // City-wise top 5
  const cityData = useMemo(() => {
    if (!filteredBody || !Array.isArray(filteredBody)) return [];
    const counts = filteredBody.reduce((acc, r) => {
      if (r.city) {
        const cityName = r.city.trim().toLowerCase();
        acc[cityName] = (acc[cityName] || 0) + 1;
      }
      return acc;
    }, {});
    return Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([city, count]) => ({
        city: city.charAt(0).toUpperCase() + city.slice(1),
        count,
      }));
  }, [filteredBody]);

  // Frequency breakdown
  const frequencyData = useMemo(() => {
    if (!filteredBody || !Array.isArray(filteredBody)) return {};
    return filteredBody.reduce((acc, r) => {
      if (r.warranty_service_frequency)
        acc[r.warranty_service_frequency] = (acc[r.warranty_service_frequency] || 0) + 1;
      return acc;
    }, {});
  }, [filteredBody]);

  // Available years from warranty_end_date
  const availableYears = useMemo(() => {
    if (!body || !Array.isArray(body)) return [];
    return [
      ...new Set(
        body.map((r) => {
          if (!r.warranty_end_date) return null;
          const d = new Date(r.warranty_end_date);
          return isNaN(d) ? null : d.getFullYear();
        }).filter(Boolean),
      ),
    ].sort((a, b) => b - a);
  }, [body]);

  // ── Effects ──
  useEffect(() => {
    const filter = { ...filterData };
    delete filter.owner_name;
    delete filter.offer_name_label;
    filter.owner_ids = filter?.owner_ids?.filter((i) => i.value)?.map((i) => i.value);
    if (Array.isArray(dateRange) && dateRange.length > 0)
      filter.date_range = {
        filed: "createddate",
        createddate: { from: formatDate(dateRange?.at(0)), to: formatDate(dateRange?.at(1)) },
      };
    if (Array.isArray(warrantyEndDateRange) && warrantyEndDateRange.length > 0)
      filter.warranty_end_date_range = {
        filed: "warranty_end_date",
        warranty_end_date: {
          from: formatDate(warrantyEndDateRange?.at(0)),
          to: formatDate(warrantyEndDateRange?.at(1)),
        },
      };
    fetchWarranties(filter);
  }, [dateRange, warrantyEndDateRange, filterData]);

  async function init() {
    if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((p) =>
      userInfo?.permissions?.map((x) => x.name).includes(p),
    )) {
      const r = await fuziElevatorsApi.fetchUsers();
      r && Array.isArray(r) &&
        setAssignUsers(r.map((u) => ({ value: u.id, label: u.username })));
    }
    if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER].some((p) =>
      userInfo?.permissions?.map((x) => x.name).includes(p),
    )) {
      fuziElevatorsApi.fetchOrders().then(
        (r) =>
          r && Array.isArray(r) &&
          setOrders(r.map((i) => ({ value: i?.id, label: i?.offer_name_label }))),
      );
    }
  }

  async function fetchWarranties(filters) {
    const result = await fuziElevatorsApi.fetchWarranties(filters);
    setBody(result || []);
  }

  useEffect(() => { init(); }, []);

  useEffect(() => {
    (async () => {
      try {
        const u = await fuziElevatorsApi.fetchUsersForListPage();
        setUsers(
          Array.isArray(u)
            ? u.map(({ id, username, userrole }) => ({ value: id, label: `${username} - ${userrole}` }))
            : [],
        );
      } catch { setUsers([]); }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (fromUser?.value) {
        setSpinnerForChangeOwner(true);
        const leads = await fuziElevatorsApi.getWarratiesByStaffId(fromUser.value);
        if (leads.success) {
          setOwnerLeads(leads.data);
          setOwnerLeadsHeader([
            {
              title: (
                <Form.Check type="checkbox" label="Select All" name="all_leads" onChange={handelCheckBox} />
              ),
              prop: "id",
              isFilterable: true,
              cell: (row) => <Form.Check type="checkbox" id={`${row.id}`} name="leads" />,
            },
            {
              title: "Order", prop: "offer_name_label", isFilterable: true,
              cell: (row) => (
                <Link to={"/warranties/" + row.id} state={row}>{row.offer_name_label}</Link>
              ),
            },
            {
              title: "Warranty Status", prop: "warranty_status",
              isFilterable: true, isSortable: true,
            },
            {
              title: "Created Date", prop: "createddate", isSortable: true, isFilterable: true,
              cell: (row) => <span>{moment(row.createddate).format("DD-MM-yyyy")}</span>,
            },
          ]);
        } else {
          setOwnerLeads([]);
          setOwnerLeadsHeader([]);
        }
        setSpinnerForChangeOwner(false);
      } else {
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
      }
    })();
  }, [fromUser]);

  const handleChange = (e) =>
    setFilterData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleClear = () => {
    setFilterData({});
    setWarrantyEndDateRange([]);
    setEndDateYear("");
    setEndDateMonth("");
    fetchWarranties();
  };

  const getStatusClass = (status) => {
    const s = Constant.WARRANTY_STATUS_VALUES?.find((v) => v.label === status);
    return s ? s.css : {};
  };

  const customFilter = (rows, filters) =>
    rows.filter((row) =>
      Object.keys(filters).every((col) => {
        const fv = filters[col]?.toLowerCase() || "";
        if (!fv) return true;
        return (row[col]?.toString().toLowerCase() || "").includes(fv);
      }),
    );

  const handelChangeOwnerModalClose = () => {
    setChangeOwnerModal(false);
    setRefreshRecords((r) => !r);
    setOwnerLeads([]);
    setOwnerLeadsHeader([]);
    setFromUser({});
    setToUser({});
    setSelectedToUsers([]);
  };

  const ChangeOwner = (e) => {
    e.preventDefault();
    let leads = [...(tableRef?.current?.querySelectorAll(`input[name='leads']`))]
      .filter((el) => el.checked)
      .map((el) => el.id);
    const toUsers = selectedToUsers.map((u) => u.value);
    (async () => {
      const result = await fuziElevatorsApi.ChangeWarrantyOwner({
        fromUser: fromUser.value,
        toUser: toUsers,
        leads,
      });
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", { title: "Transfer Owner", message: "Owner Transfer successfully" });
        setSelectedToUsers([]);
        handelChangeOwnerModalClose();
      } else
        PubSub.publish("RECORD_ERROR_TOAST", { title: "Transfer Owner Error", message: "Some error occurred" });
    })();
  };

  const handelCheckBox = (e) =>
    [...tableRef.current.querySelectorAll(`input[name='leads']`)].forEach((el) => {
      el.checked = e.target.checked;
    });

  // Table headers
  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Order", prop: "offer_name_label", isFilterable: true, isSortable: true,
        cell: (row) => (
          <Link to={`${ROUTES.WARRANTY.LIST}/${row.id}`} state={row}>{row.offer_name_label}</Link>
        ),
      },
      { title: "Site Address", prop: "site_address", isFilterable: true },
      { title: "City", prop: "city", isFilterable: true },
      { title: "Phone", prop: "phone", isFilterable: true },
      { title: "Sector", prop: "sector", isFilterable: true },
      {
        title: "Product", prop: "product_name", isFilterable: true,
        cell: (row) => (
          <Link to={`${ROUTES.PRODUCT.LIST}/${row.product_id}`}>{row.product_name}</Link>
        ),
      },
      { title: "Warranty Period", prop: "warranty_upto", isFilterable: true },
      {
        title: "Warranty Start Date", prop: "warranty_start_date", isFilterable: true, isSortable: true,
        cell: (row) => (row?.warranty_start_date ? formatDateForView(row.warranty_start_date) : ""),
      },
      {
        title: "Warranty Upto", prop: "warranty_end_date", isFilterable: true, isSortable: true,
        cell: (row) => (row?.warranty_end_date ? formatDateForView(row.warranty_end_date) : ""),
      },
      { title: "Warranty Service Frequency", prop: "warranty_service_frequency" },
      {
        title: "Warranty Status", prop: "warranty_status", isFilterable: true, isSortable: true,
        alignment: { horizontal: "center" },
        cell: (row) => (
          <span className="badge rounded-pill w-100" style={getStatusClass(row.warranty_status)}>
            {row.warranty_status}
          </span>
        ),
      },
      {
        title: "Assign Users", prop: "owner_ids", isFilterable: true,
        cell: (row) => (
          <div className="d-flex flex-wrap gap-1">
            {row.owner_ids?.map((item, index) =>
              item?.value && (
                <Link
                  key={index}
                  to={`${ROUTES.USER.LIST}/${item.value}`}
                  state={row}
                  className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                  style={{ background: "#f5f7fa", border: "1px solid #e0e0e0", transition: "0.2s" }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#eaf1ff")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "#f5f7fa")}
                >
                  <span className="fw-semibold text-primary">{item.label}</span>
                </Link>
              )
            )}
          </div>
        ),
      },
    );
  } else {
    header.push({
      title: "Info", prop: "offer_name", isFilterable: true, isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link to={`${ROUTES.WARRANTY.LIST}/${row.id}`} state={row} style={{ width: "100%" }}>
            {row.offer_name}
          </Link>
          <span><i className="fa-solid fa-phone"></i> {row.phone}</span>
          <span style={{ width: "80%" }}><i className="fa-solid fa-envelope"></i> {row.email}</span>
        </div>
      ),
    });
  }

  const cityColors = ["#378ADD", "#1D9E75", "#EF9F27", "#7F77DD", "#D85A30"];
  const freqColors = ["#378ADD", "#7F77DD", "#1D9E75", "#EF9F27", "#D85A30"];

  return (
    <>
      <style>{styles}</style>
      <div className="wrn-root">
        {/* ── Page Header ── */}
        <div className="wrn-page-title">Warranty Management</div>
        <div className="wrn-breadcrumb">
          <a href="#">Dashboard</a> › Warranty Management
        </div>
        <div className="wrn-page-desc">Manage and track all product warranties</div>

        {/* ── Stat Cards ── */}
        <div className="wrn-stat-grid">
          <StatCard
            icon="fa-solid fa-layer-group"
            iconBg="#E6F1FB" iconColor="#185FA5"
            label="Total Records"
            num={total.toLocaleString("en-IN")}
            numColor="#1a1d23"
            sub="All warranty records"
            sparkColor="#378ADD"
            sparkPoints="0,22 20,17 40,20 60,12 80,15 100,7 120,11"
            accentColor="#378ADD"
          />
          <StatCard
            icon="fa-solid fa-gear"
            iconBg="#E3F0FF" iconColor="#0A5DB5"
            label="Work in Progress"
            num={workInProgressCount.toLocaleString("en-IN")}
            numColor="#1E90FF"
            sub={`${total ? Math.round((workInProgressCount / total) * 100) : 0}% of total`}
            sparkColor="#1E90FF"
            sparkPoints="0,20 20,16 40,18 60,10 80,14 100,6 120,9"
            accentColor="#1E90FF"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "Order Work in Progress" }))}
          />
          <StatCard
            icon="fa-solid fa-circle-check"
            iconBg="#FCE3EE" iconColor="#9B0040"
            label="Work Complete"
            num={workCompleteCount.toLocaleString("en-IN")}
            numColor="#eb0c61"
            sub={`${total ? Math.round((workCompleteCount / total) * 100) : 0}% of total`}
            sparkColor="#eb0c61"
            sparkPoints="0,18 20,14 40,20 60,12 80,16 100,8 120,12"
            accentColor="#eb0c61"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "Order Work Complete" }))}
          />
          <StatCard
            icon="fa-solid fa-shield-halved"
            iconBg="#EDE7F6" iconColor="#4A2D7A"
            label="Warranty Running"
            num={warrantyRunningCount.toLocaleString("en-IN")}
            numColor="#7851A9"
            sub={`${total ? Math.round((warrantyRunningCount / total) * 100) : 0}% of total`}
            sparkColor="#7851A9"
            sparkPoints="0,20 20,15 40,17 60,9 80,11 100,4 120,8"
            accentColor="#7851A9"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "Warranty Running" }))}
          />
          <StatCard
            icon="fa-solid fa-shield-xmark"
            iconBg="#E8EDE5" iconColor="#2C3D22"
            label="Warranty Lost"
            num={warrantyLostCount.toLocaleString("en-IN")}
            numColor="#476038"
            sub={`${total ? Math.round((warrantyLostCount / total) * 100) : 0}% of total`}
            sparkColor="#476038"
            sparkPoints="0,22 20,22 40,20 60,22 80,20 100,18 120,14"
            accentColor="#476038"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "Warranty Lost" }))}
          />
          <StatCard
            icon="fa-solid fa-rotate"
            iconBg="#E0F2F2" iconColor="#004D4D"
            label="AMC Running"
            num={amcRunningCount.toLocaleString("en-IN")}
            numColor="#008080"
            sub={`${total ? Math.round((amcRunningCount / total) * 100) : 0}% of total`}
            sparkColor="#008080"
            sparkPoints="0,18 20,14 40,20 60,11 80,15 100,7 120,11"
            accentColor="#008080"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "AMC Running" }))}
          />
          <StatCard
            icon="fa-solid fa-ban"
            iconBg="#FCEBEB" iconColor="#A32D2D"
            label="AMC Lost"
            num={amcLostCount.toLocaleString("en-IN")}
            numColor="#E24B4A"
            sub={`${total ? Math.round((amcLostCount / total) * 100) : 0}% of total`}
            sparkColor="#E24B4A"
            sparkPoints="0,22 20,20 40,22 60,20 80,18 100,16 120,12"
            accentColor="#E24B4A"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "AMC Lost" }))}
          />
          <StatCard
            icon="fa-solid fa-rocket"
            iconBg="#E0F5F5" iconColor="#1A7570"
            label="AMC Direct Order"
            num={amcDirectOrderCount.toLocaleString("en-IN")}
            numColor="#2aada7"
            sub={`${total ? Math.round((amcDirectOrderCount / total) * 100) : 0}% of total`}
            sparkColor="#2aada7"
            sparkPoints="0,16 20,12 40,18 60,10 80,14 100,6 120,10"
            accentColor="#2aada7"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "AMC Direct Order" }))}
          />
          <StatCard
            icon="fa-solid fa-calendar-day"
            iconBg="#F5E5E5" iconColor="#6B1E1E"
            label="One Time"
            num={oneTimeCount.toLocaleString("en-IN")}
            numColor="#9b3131"
            sub={`${total ? Math.round((oneTimeCount / total) * 100) : 0}% of total`}
            sparkColor="#9b3131"
            sparkPoints="0,20 20,16 40,22 60,14 80,18 100,10 120,14"
            accentColor="#9b3131"
            onClick={() => setFilterData((p) => ({ ...p, warranty_status: "One Time" }))}
          />
        </div>

        {/* ── Insights Section ── */}
        {filteredBody && Array.isArray(filteredBody) && total > 0 && (
          <>
            <div className="wrn-insights-title">
              <i className="fa-solid fa-chart-pie" style={{ color: "#378ADD", fontSize: 13 }}></i>
              Warranty Insights
            </div>
            <div className="wrn-insights-grid">
              {/* Status Breakdown */}
              <div className="wrn-insight-card">
                <div className="wrn-insight-card-head">Status Breakdown</div>
                <div className="wrn-insight-card-body">
                  <div className="wrn-donut-wrap">
                    <DonutChart data={statusCards} total={total} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {statusCards.map(({ label, color, count }) => (
                        <div
                          key={label}
                          onClick={() => setFilterData((p) => ({ ...p, warranty_status: label }))}
                          style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 11, color: "#555", marginBottom: 7, cursor: "pointer" }}
                        >
                          <span style={{ width: 8, height: 8, borderRadius: "50%", background: color, flexShrink: 0 }}></span>
                          <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                          <strong style={{ color: "#1a1d23", fontFamily: "'Space Grotesk', sans-serif" }}>
                            {count.toLocaleString("en-IN")}
                          </strong>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Service Frequency */}
              <div className="wrn-insight-card">
                <div className="wrn-insight-card-head">Service Frequency</div>
                <div className="wrn-insight-card-body">
                  {Object.entries(frequencyData).sort((a, b) => b[1] - a[1]).map(([freq, count], idx) => {
                    const pct = total > 0 ? Math.round((count / total) * 100) : 0;
                    const c = freqColors[idx % freqColors.length];
                    return (
                      <div key={freq} style={{ marginBottom: 12 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#555", marginBottom: 5, alignItems: "center" }}>
                          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <span style={{ width: 8, height: 8, borderRadius: "50%", background: c, flexShrink: 0 }}></span>
                            {freq}
                          </span>
                          <span style={{ fontWeight: 600, color: "#1a1d23", fontFamily: "'Space Grotesk', sans-serif" }}>
                            {count.toLocaleString("en-IN")} <span style={{ color: "#b0b8c8", fontWeight: 400 }}>({pct}%)</span>
                          </span>
                        </div>
                        <div className="wrn-progress-track">
                          <div className="wrn-progress-fill" style={{ width: `${pct}%`, background: c }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Top Cities */}
              {cityData.length > 0 && (
                <div className="wrn-insight-card">
                  <div className="wrn-insight-card-head">Top Cities</div>
                  <div className="wrn-insight-card-body">
                    {cityData.map(({ city, count }, idx) => {
                      const pct = cityData[0].count > 0 ? Math.round((count / cityData[0].count) * 100) : 0;
                      const c = cityColors[idx];
                      return (
                        <div key={city} style={{ marginBottom: 10 }}>
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#555", marginBottom: 4, alignItems: "center" }}>
                            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <span className="wrn-legend-pill" style={{ color: c, background: c + "18" }}>#{idx + 1}</span>
                              {city}
                            </span>
                            <strong style={{ color: "#1a1d23", fontFamily: "'Space Grotesk', sans-serif" }}>{count}</strong>
                          </div>
                          <div className="wrn-progress-track" style={{ height: 4 }}>
                            <div className="wrn-progress-fill" style={{ width: `${pct}%`, background: c, height: 4 }} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Retention Overview */}
              <div className="wrn-insight-card">
                <div className="wrn-insight-card-head">Warranty Overview</div>
                <div className="wrn-insight-card-body" style={{ padding: "8px 14px" }}>
                  {[
                    // { label: "Order Work in Progress", count: workInProgressCount,  color: "#1E90FF", icon: "fa-solid fa-gear" },
                    // { label: "Order Work Complete",    count: workCompleteCount,     color: "#eb0c61", icon: "fa-solid fa-circle-check" },
                    { label: "Warranty Running",       count: warrantyRunningCount,  color: "#7851A9", icon: "fa-solid fa-shield-halved" },
                    { label: "Warranty Lost",          count: warrantyLostCount,     color: "#476038", icon: "fa-solid fa-shield-xmark" },
                    { label: "AMC Running",            count: amcRunningCount,       color: "#008080", icon: "fa-solid fa-rotate" },
                    { label: "AMC Lost",               count: amcLostCount,          color: "#E24B4A", icon: "fa-solid fa-ban" },
                    // { label: "AMC Direct Order",       count: amcDirectOrderCount,   color: "#2aada7", icon: "fa-solid fa-rocket" },
                    // { label: "One Time",               count: oneTimeCount,          color: "#9b3131", icon: "fa-solid fa-calendar-day" },
                  ].map(({ label, count, color, icon }) => (
                    <div
                      key={label}
                      className="wrn-retention-row"
                      onClick={() => setFilterData((p) => ({ ...p, warranty_status: label }))}
                    >
                      <div style={{ width: 28, height: 28, borderRadius: "50%", background: color + "18", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <i className={icon} style={{ fontSize: 12, color }}></i>
                      </div>
                      <span style={{ flex: 1, fontSize: 12, color: "#555" }}>{label}</span>
                      <span style={{ fontSize: 14, fontWeight: 700, color, fontFamily: "'Space Grotesk', sans-serif" }}>
                        {count.toLocaleString("en-IN")}
                      </span>
                      <span style={{ fontSize: 10, color: "#b0b8c8", minWidth: 28, textAlign: "right" }}>
                        {total > 0 ? Math.round((count / total) * 100) : 0}%
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/* ── Datatable ── */}
        <Container fluid style={{ padding: 0 }}>
          <DatatableWrapper
            body={filteredBody && Array.isArray(filteredBody) ? filteredBody : []}
            headers={header}
            paginationOptionsProps={{
              initialState: { rowsPerPage: 50, options: [5, 10, 15, 20, 30, 50] },
            }}
            sortProps={{ initialState: { prop: "warranty_end_date", order: "asc" } }}
            filterFunction={customFilter}
          >
            {/* ── Filter Card ── */}
            <div className="wrn-filter-card">
              <div className="wrn-filter-row">
                <div className="wrn-filter-col-lg">
                  <label className="wrn-filter-label">Search</label>
                  <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
                </div>
                <div className="wrn-filter-col">
                  <label className="wrn-filter-label">Warranty Status</label>
                  <Form.Select
                    name="warranty_status"
                    value={filterData?.warranty_status || ""}
                    onChange={handleChange}
                    className="wrn-filter-select"
                  >
                    <option value="">All Status</option>
                    {Constant.WARRANTY_STATUS_VALUES?.map((status, i) => (
                      <option key={i} value={status.label}>{status.label}</option>
                    ))}
                  </Form.Select>
                </div>
                <div className="wrn-filter-col-sm">
                  <label className="wrn-filter-label">Warranty Year</label>
                  <Form.Select
                    value={endDateYear}
                    onChange={(e) => setEndDateYear(e.target.value)}
                    className="wrn-filter-select"
                  >
                    <option value="">All Years</option>
                    {availableYears.map((y) => (
                      <option key={y} value={y.toString()}>{y}</option>
                    ))}
                  </Form.Select>
                </div>
                <div className="wrn-filter-col-sm">
                  <label className="wrn-filter-label">Warranty Month</label>
                  <Form.Select
                    value={endDateMonth}
                    onChange={(e) => setEndDateMonth(e.target.value)}
                    className="wrn-filter-select"
                  >
                    <option value="">All Months</option>
                    {MONTHS.map((m, i) => (
                      <option key={i + 1} value={(i + 1).toString()}>{m}</option>
                    ))}
                  </Form.Select>
                </div>
                <div className="wrn-filter-col-lg">
                  <label className="wrn-filter-label">Assigned To</label>
                  <Select
                    isMulti
                    name="owner_ids"
                    classNamePrefix="react-select"
                    className="z-3"
                    onChange={(e) => handleChange({ target: { name: "owner_ids", value: e } })}
                    value={filterData?.owner_ids?.filter((i) => i.value)}
                    options={assignUsers}
                    styles={{
                      control: (b) => ({ ...b, fontSize: 12, minHeight: 36, borderRadius: 8, borderColor: "#dde3ef" }),
                    }}
                  />
                </div>
                <div className="wrn-filter-col-sm">
                  <label className="wrn-filter-label">Per Page</label>
                  <PaginationOptions labels={{ beforeSelect: " " }} />
                </div>
                <div className="wrn-filter-actions">
                  <button className="wrn-btn-secondary" onClick={handleClear}>
                    <i className="fa fa-refresh" style={{ fontSize: 10 }}></i> Reset
                  </button>
                  {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_WARRANTY].some((p) =>
                    userInfo?.permissions?.map((x) => x.name).includes(p),
                  ) && (
                    <button className="wrn-btn-primary" onClick={() => navigate(ROUTES.WARRANTY.CREATE)}>
                      <i className="fa-solid fa-plus" style={{ fontSize: 10 }}></i> New Warranty
                    </button>
                  )}
                  {userInfo?.userrole === "SUPER_ADMIN" && (
                    <button
                      className="wrn-btn-primary"
                      style={{ background: "#7F77DD" }}
                      onClick={() => setChangeOwnerModal(true)}
                    >
                      <i className="fa-solid fa-shuffle" style={{ fontSize: 10 }}></i> Transfer
                    </button>
                  )}
                </div>
              </div>

              <button
                className="wrn-advanced-toggle"
                onClick={() => setShowAdvanced((p) => !p)}
              >
                <i className={`fa-solid fa-chevron-${showAdvanced ? "down" : "right"}`} style={{ fontSize: 9 }}></i>
                Advanced Filters
              </button>

              {showAdvanced && (
                <div className="wrn-filter-row" style={{ marginTop: 12 }}>
                  <div className="wrn-filter-col-lg">
                    <label className="wrn-filter-label">Order</label>
                    <Select
                      placeholder="Select Order"
                      classNamePrefix="react-select"
                      className="z-3"
                      options={orders}
                      onChange={(e) => {
                        handleChange({ target: { name: "order_id", value: e.value } });
                        handleChange({ target: { name: "offer_name_label", value: e.label } });
                      }}
                      value={filterData?.order_id ? { value: filterData.order_id, label: filterData.offer_name_label } : ""}
                      styles={{
                        control: (b) => ({ ...b, fontSize: 12, minHeight: 36, borderRadius: 8, borderColor: "#dde3ef" }),
                      }}
                    />
                  </div>
                  <div className="wrn-filter-col-sm">
                    <label className="wrn-filter-label">Created Date Range</label>
                    <DateRangePicker value={dateRange} onChange={(e) => setDateRange(e)} character=" – " />
                  </div>
                  <div className="wrn-filter-col-lg">
                    <label className="wrn-filter-label">Warranty End Date Range</label>
                    <DateRangePicker
                      value={warrantyEndDateRange}
                      onChange={(e) => setWarrantyEndDateRange(e)}
                      character=" – "
                      placeholder="Warranty End Date"
                    />
                  </div>
                </div>
              )}
            </div>

            {/* ── Table Card ── */}
            <div className="wrn-table-card">
              <div className="wrn-table-head">
                <div className="wrn-table-title">
                  Warranty Records{" "}
                  <span className="wrn-table-count">({total.toLocaleString("en-IN")})</span>
                </div>
              </div>
              <div className="wrn-table-scroll table-scroll">
                <Table striped className="shadow-sm rounded">
                  <TableHeader classes={{ th: "bg-custom text-white sticky-header" }} />
                  {filteredBody && Array.isArray(filteredBody) ? (
                    <TableBody />
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={100} align="center" style={{ padding: 40 }}>
                          <Spinner />
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
              <div className="wrn-table-foot">
                <span className="wrn-table-foot-text">
                  Total: <strong style={{ color: "#1a1d23" }}>{total.toLocaleString("en-IN")}</strong> records
                </span>
                <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
              </div>
            </div>
          </DatatableWrapper>
        </Container>

        {/* ── Transfer Owner Modal ── */}
        {changeOwnerModal && (
          <Modal show={changeOwnerModal} onHide={handelChangeOwnerModalClose} size="xl" centered>
            <Modal.Header closeButton>
              <Modal.Title style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 16 }}>
                Transfer Owner
              </Modal.Title>
            </Modal.Header>
            <Form onSubmit={ChangeOwner}>
              <Modal.Body>
                <Row className="gap-3">
                  <Col lg={12}>
                    <Row>
                      <Col lg={6} xs={12} className="mb-3 mb-lg-0">
                        <FormGroup>
                          <FormLabel style={{ fontSize: 12, fontWeight: 600 }}>From</FormLabel>
                          <Select
                            isClearable
                            options={users}
                            onChange={(e) => setFromUser(e || {})}
                            name="fromUser"
                            required
                            styles={{
                              control: (b) => ({ ...b, fontSize: 12, borderRadius: 8, borderColor: "#dde3ef" }),
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} xs={12}>
                        <FormGroup>
                          <UserMultiSelect
                            options={users}
                            value={selectedToUsers}
                            onChange={setSelectedToUsers}
                            label="To"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {fromUser && Object.keys(fromUser).length > 0 && (
                  <Container style={{ height: "50vh", overflowY: "auto", marginTop: 16 }}>
                    {!spinnerForChangeOwner ? (
                      <DatatableWrapper body={ownerLeads} headers={ownerLeadsHeader}>
                        <Table striped className="data-table" ref={tableRef}>
                          <TableHeader />
                          <TableBody />
                        </Table>
                      </DatatableWrapper>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center mt-5">
                        <Spinner animation="border" variant="secondary" />
                      </div>
                    )}
                  </Container>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="success" type="submit">Change</Button>
                <Button onClick={handelChangeOwnerModalClose} variant="light">Close</Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}
      </div>
    </>
  );
};

export default WarrantyList;